import { Device } from '@styles/media/types';

export const device: Device = {
  mobileSmall: 'only screen and (max-width: 320px)',
  mobile: 'only screen and (max-width: 1139px)',
  mobileMedium: 'only screen and (max-width: 600px)',
  desktop: 'only screen and (min-width: 1140px)',
};
